import { Types } from './types'

const initialState = {
    dataPartner: {
        rows: [],
        paging: {}
    },
    dataPartnerGroup: {
        rows: [],
        paging: {}
    }
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_PARTNER:
            return {
                ...newState,
                dataPartner: action.payload
            }
        case Types.SAVE_LIST_PARTNER_GROUP:
            return {
                ...newState,
                dataPartnerGroup: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
